import {connect} from 'react-redux';
import {isNil} from 'lodash/fp';
import {AnyAction} from 'redux';
import {Dispatch} from 'redux';
import {createStructuredSelector} from 'reselect';

import {getPerformance, getRankProgression} from '/redux/action/coach.action';
import {
  competencyById,
  hasEarningsById,
  hasPerformanceById,
  nextRankIdById,
  rankProgressionByCoachAndRankIds,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {testingDate} from '/redux/selector/testingOptions.selector';
import {generateCallback} from '/util/component.util';
import {withProps} from '/util/selector.util';

import Performance from './Performance';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    userId,
    rankId: withCurrentUserCoachId(nextRankIdById),
    hasPerformance: withCurrentUserCoachId(hasPerformanceById),
    currentUserCompetency: withCurrentUserCoachId(competencyById),
    hasEarnings: withCurrentUserCoachId(hasEarningsById),
    progressionData: withProps({
      rankId: withCurrentUserCoachId(nextRankIdById),
      coachId: userId,
    })(rankProgressionByCoachAndRankIds),
    testingDate: testingDate,
  }),
  (dispatch: Dispatch<AnyAction>) => ({
    getPerformance: (inputPayload: {coachId: string}) =>
      dispatch(getPerformance(inputPayload) as unknown as AnyAction),
    getRankProgression: (inputPayload: {coachId: string; rankId: string}) =>
      dispatch(getRankProgression(inputPayload) as unknown as AnyAction),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {
      userId: coachId,
      hasPerformance,
      hasEarnings,
      progressionData,
    } = stateProps;
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      hasPerformanceMetrics: hasPerformance && hasEarnings,
      hasProgressionData: !isNil(progressionData),
      getRankProgression: generateCallback({
        func: dispatchProps.getRankProgression,
        params: {
          coachId,
          rankId: stateProps.rankId!,
        },
      }),
      getPerformanceMetrics: () =>
        Promise.all([dispatchProps.getPerformance({coachId})]),
    };
  },
)(Performance);
